/* eslint-disable no-useless-return */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import FileBase64 from "react-file-base64";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton,
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { MdReplay } from "react-icons/md";
import styles from "./OperativeTimeBookingSheet.module.css";
import { setLogin } from '../../redux/features/auth/actions';

import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../../components/FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button, CustomTab } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import BackButton from "../../components/BackButton/BackButton";
import {
  setToast,
  setPORow,
  poSearch,
  fetchChassis,
  setChassisData,
  setAllDetails,
  getInvoice,
} from "../../redux/actions/productsActions";
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import MultiSelect from "../../components/FormComponents/MultiSelect";
import { canDeleteBooking } from "../../utils/utils";

const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: "",
  },
  errors: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

const ReportShiftUtilizationForm = () => {
  const ROW_HEIGHT = 38;
  const history = useHistory();

  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0,
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  // const dispatch1 = useDispatch();
  const dispatchNew= useDispatch();


  const {
    damage,
    invoice,
    plant,
    part,
    aqCommodity,
    purchaseCommodity,
    supplierCode,
    supplierDetails,
    supplierName,
    supplierLocation,
    selectedProject,
    selectedPO,
    inputFields,
    errors,
  } = state;

  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); //
  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  // const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [deleteRow, setDeleteRow] = useState();
  const [deleteData, setDeletedData] = useState();
  const [opTicketNo, setOpTicketNo] = useState();
  const [barrelData, setBarrelData] = useState(false);
  const [barrelDropdown, setBarrelDropdown] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const[totalProject,setTotalProject]=useState([])


  // const [wbsData, setWbsData] = useState(false);
  const [projectData, setProjectData]= useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [companyCodeOption, setCompanyCode] = useState([]);
  const [tableData1, setTableData1] = useState();
  const [selectedProjectsDetails, setSelectedProjectsDetails] = useState([]);
  const [projectInfo, setProjectInfo] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [modifiedData, setModifiedData] = useState([]);
  const [dataDB, setDataDB] = useState([]);
  // const [isWarningOpen, setIsWarningOpen] = useState(false);
  // const [warningMessage, setWarningMessage] = useState("");

  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    persArea,
  } = auth;

  const [myState, setState] = React.useState({
    // poNo: "",
    // wbs_no: null,
    project_def:null,
    barrel_code: null,
    toDate: null,
    fromDate: null,
    // bodyBuilder: null,
    // checkFlag: false,
  });

  useEffect(() => {
    if (selectedProjectsDetails.length > 0) {
      handleSelectedProjectsChange(selectedProjectsDetails);
    }
  }, [selectedProjectsDetails]);

  useEffect(() => {
    if (checkedItems.length != 0) {
      updateFinalData();
    }
  }, [checkedItems, modifiedData]);
  const setCount = (count) => {
    setAsnCount(count);
  };

  // LOGIC FOR DATE SET====================
  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;
    }
    let newDate = date.format(DATE_FORMAT.ISO);
    setState((prevData) => ({ ...prevData, [name]: newDate }));
  };
 
  const handleDropdown = (data , name) => {
    setBarrelData(true)
    if(name == 'project_def'){
     setProjectData(true)
    }
     if(data == null){
 setState((prevData) => ({ ...prevData, [name]: null }))
}
else{
setState((prevData) => ({ ...prevData, [name]: data }))
}

if(name=="barrel_code"){
 if(data){
   let newData=data?.map((data1)=>data1.value)
   let filterData=totalData?.filter((datas)=>newData?.includes(datas.code_code))
   let keyValue=filterData?.map(({project_def,project})=>({
    label:project,
    value:project_def
   }))
   let jsonObject = keyValue?.map(JSON.stringify);
   let uniqueSet = new Set(jsonObject);
   let uniqueArray = Array.from(uniqueSet)?.map(JSON.parse); 
  setpro_NoDropdown(uniqueArray) 
 }
   else{
     setpro_NoDropdown(totalProject) 
   }        
}


}

  const location = useLocation();
  const selectedDates1 = location.state && location.state.selectedDates1 ? location.state.selectedDates1 : [];
  // console.log("selectedDates1 -> ", selectedDates1)
  const [datesComingFromCalendar, setDatesComingFromCalendar] = useState(selectedDates1);
  // ========================================
  // CODE START FROM HERE
  // CODE FOR GET DATA IN DROPDOWN
  const [BarrelDropdown, setbarrelDropdown] = useState([]);
  // const [WBS_NoDropdown, setwBS_NoDropdown] = useState([]);
  const [Pro_NoDropdown, setpro_NoDropdown] = useState([]);
  const [tableData, setTableData] = useState([]);
  // console.log("final", BarrelDropdown, Pro_NoDropdown);
  const getIndivisualDetails = () => {
    let apiFormatedData = {
      pers_no: personNumber,
      co_code: companyCode,
    };
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    // console.log("final", apiFormatedDataJson);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}timeBooking/GetBookingDetailsIndividual`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson) {
        const barrelList=[]
        responseJson.result.Barrel_data.map((row)=>{
          barrelList.push({label:row.code_desc,value:row.code_code})
        })
        let jsonObjects = barrelList?.map(JSON.stringify);
        let uniqueSets = new Set(jsonObjects);
        let uniqueArray = Array.from(uniqueSets)?.map(JSON.parse); 
        setBarrelDropdown(uniqueArray)
        setTotalData(responseJson.result.Barrel_data)
      
        const Project_Nodropdown = []
        responseJson.result.project_data.map((row)=>{
          Project_Nodropdown.push({ label: row.project, value: row.peoject_def});
       
        
      })
      setTotalProject(Project_Nodropdown)
        setpro_NoDropdown(Project_Nodropdown);
        
      }
      else {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Blank message",
        });
      }

    }).catch((error) => {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Oops! Something went wrong. Please try again later",
        });
      });
  };


  useEffect(() => {
    getIndivisualDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // CODE FOR POST THE DATE WITH API
  const handleSearch = () => {
  
    setState((prevState) => ({ ...prevState, checkTable: true }));

    if (fromDate == "" || toDate == "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Dates are Required",
      });
      setTableData([]);
    } else {
      let apiFormatedData = {
        co_code: companyCode,
        // pers_no: opTicketNo[0],
        pers_no: personNumber,
        start_date: toDate,
        end_date: fromDate,
        barrel_code: myState.barrel_code ? myState.barrel_code.map((item) => item.value).join(",") : "",
        project_def: myState.project_def ? myState.project_def.map((item) => item.value).join(",") : "",
      };

      // supno: "280339",
      // console.log(apiFormatedData, "apiFormatedData");
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      // console.log("final", apiFormatedDataJson);
      let headerss = new Headers();;
      headerss.append("Content-Type", "application/json");
      // console.log(headerss, "headerss");
      fetch(`${baseUrl}timeBooking/SearchOperativeDetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson) {
            if (responseJson.result == undefined || responseJson.result == 0) {
              
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Data not found",
              });
            }
            setSelectedProjectsDetails(responseJson.result);
          } else {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Empty Table Data",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Empty Table Data",
          });
        });
    }
  };



  const handleSearchCalendar = () => {
    setState((prevState) => ({ ...prevState, checkTable: true }));

    if (fromDate == "" || toDate == "") {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Dates are Required",
      });
      setTableData([]);
    } else {
      let apiFormatedData = {}
      if (datesComingFromCalendar.length === 1) {
        let formattedDate  = moment(datesComingFromCalendar[0]).format('YYYY-MM-DDTHH:mm:ss.SSS');
        apiFormatedData = {
          co_code: companyCode,
          pers_no: personNumber,
          start_date: formattedDate,
          end_date: formattedDate,
          barrel_code: barrelData
            ? myState.barrel_code?.map((item) => item.value).join(",")
            : "",
          project_def: projectData ? myState.project_def?.map((item) => item.value).join(","): ""
        };
      } else if (datesComingFromCalendar.length > 1) {
        let formattedDate1  = moment(datesComingFromCalendar[0]).format('YYYY-MM-DDTHH:mm:ss.SSS');
        let formattedDate2  = moment(datesComingFromCalendar[datesComingFromCalendar.length - 1]).format('YYYY-MM-DDTHH:mm:ss.SSS');
        apiFormatedData = {
          co_code: companyCode,
          pers_no: personNumber,
          start_date: formattedDate2,
          end_date: formattedDate1,
          barrel_code: barrelData
            ? myState.barrel_code?.map((item) => item.value).join(",")
            : "",
          project_def: projectData ? myState.project_def?.map((item) => item.value).join(","): ""
        };
      }

      // console.log(apiFormatedData, "apiFormatedData");
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      // console.log("final", apiFormatedDataJson);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      // console.log(headerss, "headerss");
      fetch(`${baseUrl}timeBooking/SearchOperativeDetails`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson) {
            
            if (responseJson.result == undefined || responseJson.result == 0) {
              
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "Data not found",
              });
            }
            setSelectedProjectsDetails(responseJson.result);
          } else {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Empty Table Data",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Empty Table Data",
          });
        });
    }
  };

  useEffect(() => {
    if (datesComingFromCalendar.length != 0) {
      handleSearchCalendar()
    }
  }, [])
  const handleCheckboxChange = (event, index) => {
    const { checked } = event.target;
  
    // Update the checkbox for the clicked row
    setCheckedItems((prevState) => ({
      ...prevState,
      [index]: checked,
    }));
  
    // If the checkbox is checked, find other checkboxes with the same date and select them
    if (checked) {
      const selectedDate = selectedProjectsDetails[index]?.date;
      
      // Find the indices of other items with the same date
      const indicesWithSameDate = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to select checkboxes with the same date
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDate.forEach((i) => {
          updatedState[i] = true;
        });
        return updatedState;
      });
    } else {
      // If the checkbox is unchecked, deselect other checkboxes with the same date
      const selectedDate = selectedProjectsDetails[index]?.date;
      const indicesWithSameDate = selectedProjectsDetails.reduce(
        (accumulator, item, i) => {
          if (item.date === selectedDate) {
            accumulator.push(i);
          }
          return accumulator;
        },
        []
      );
  
      // Update the state to deselect checkboxes with the same date
      setCheckedItems((prevState) => {
        const updatedState = { ...prevState };
        indicesWithSameDate.forEach((i) => {
          updatedState[i] = false;
        });
        return updatedState;
      });
    }
  };
  
  

  const updateFinalData = () => {
    const filteredData = modifiedData.filter(
      (item, index) => checkedItems[index] === true
    );
    // console.log(filteredData,"filteredData 524 priya search")
    setFinalData(filteredData);
  };

  useEffect(() => {
    if (finalData.length !== 0) {
      const resultList = finalData.map((projectData) => ({
        co_code: companyCode,
        pers_no: personNumber,
        booking_date: projectData.date,
        approval_status: projectData.approval_status,
      }));
      setDataDB(resultList);
    }
  }, [finalData]);

  const handleSelectedProjectsChange = (newSelectedProjects) => {
    // console.log(newSelectedProjects,"newSelectedProjects 609 priya")
    const newModifiedData = newSelectedProjects.map((item) => ({
      ...item,
      remark: item.remark || "",
    }));
    setModifiedData(newModifiedData);
  };
  const isCheckStatus = finalData.some(
    (row) => !canDeleteBooking(row)
  );
  const handleDelete = () => {
    if (finalData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select at least one project.",
      });
      return; // Stop further processing
    }
    else{
      const hasInvalidDeletion = finalData.some(
        (row) => !canDeleteBooking(row)
      );
      const deletableProjects = finalData.filter((projectData) =>
        canDeleteBooking(projectData)
      );
      if (hasInvalidDeletion) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Deletion not allowed based on approval or booking date rules.",
        });
        return;
      }
      else{
      // console.log(currentMonthProjects,'currentMonthProjects')
      const resultList = deletableProjects.map((projectData) => ({
      co_code: companyCode,
      pers_no: personNumber,
      booking_date: projectData.date,
      approval_status: projectData.approval_status_code,
      }));
      axios
      .post(`${baseUrl}timeBooking/DeleteOperativeDetails`, resultList,{
        headers: {
        'Content-Type': 'application/json',
        },
        withCredentials:true
      })
      .then((res) => {
        dispatchNew(setLogin({...auth, recentStatus: res.status}))
        // console.log(res, "res.msg");
        if (res.data.msg === "Booking Deleted Successfully...") {
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: res.data.msg,
            reloads: true, // Set reload to true or false based on your condition
          });
        }
        else{
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: res.data.msg,
            reloads: true, // Set reload to true or false based on your condition
          });
        }
      })
      .catch((error) => {
        dispatchNew(setLogin({...auth, recentStatus: error.response.status }));
        console.error("Error while deleting projects:", error);
      });
    }}
  };  
  const BG_COLOR = "#fffef8";
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });
  const handleCancelClick = () => {
    window.location.reload();
  };

  const handleClose = () => setIsPopupOpen(false);
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };
  const renderOther = () => (
    <div
      className={styles.formGroup}
      // style={{ backgroundColor: processInfoBg ? BG_COLOR : null }}
      onClick={() => changeBackgroundColor("processInfoBg")}
    >
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        // className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                // value={myState.fromDate}
                value={toDate}
                onChange={(date) => setToDate(date)}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <CustomDatePicker
                // isMandatory

                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                // value={myState.toDate}
                value={fromDate}
                onChange={(date) => setFromDate(date)}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        // className={styles.myGrid}
        columns={12}
      >
        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Barrel</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
            <MultiSelect
              isMandatory
              className={clsx(styles.select, styles.sel2)}
              isMulti={true}
              isClearable
              options={barrelDropdown}
              // name="city"
              onChange={(e) => {
                // setSelectedBC(selectedOption);
                handleDropdown(e, "barrel_code");
              }}
              value={myState.barrel_code}

            />
          </div>
        </Grid>
        <Grid item md={2} lg={2} sm={3} xs={3}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Project No.</label>
            </div>
          </div>
        </Grid>
        <Grid item md={3} lg={3} sm={9} xs={9}>
          <div className={styles.rowDiv}>
            <MultiSelect
              isMandatory
              className={clsx(styles.select, styles.sel2)}
              isMulti={true}
              isClearable
              options={Pro_NoDropdown}
              value={myState.project_def}
              // name="city"
              onChange={(e) => {
                // setSelectedBC(selectedOption);
                handleDropdown(e, "project_def");
              }}
            />
          </div>
        </Grid>
        <Grid item md={2} lg={2} sm={12} xs={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                onClick={() => runPreSubmissionChecks() && handleSearch()}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Search
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
          <Grid
            container
            spacing={1}
            style={{ marginTop: "10px" }}
            // className={styles.myGrid}
            columns={12}
          >
           
            <Grid item md={12} lg={12} xs={12} sm={12} className={clsx(styles.scrollBar)}>
              <TableSimple
                tableColumnData={selectedProjectsDetails?.map(
                  (item, index) => ({
                    select: (
                     
                        <input
                        type="checkbox"
                        checked={checkedItems[index] || false}
                        disabled={!canDeleteBooking(item)}
                        onChange={(event) =>
                          // console.log(event.target.checked,event,event.target,"test")
                          handleCheckboxChange(event, index)
                        }
                      />
                      
                      
                    ),
                  
                    Date :moment(item.date).format("DD-MM-YYYY"),
                    ProjectNo:item.project_def == null ? ""  : item.project_def,
                    ProjectDesc:item.project_desc == null ? ""  : item.project_desc,
                    Gate: item.activity_desc,
                    Module: item.mfl,
                    Status: item.approval_status,
                    Hrs: item.hrs,
                  })
                )}
                tableHeaderLabel={[
                  "Select_27",
                  "Date_48",
                  // "Project Details",
                  "Project/Indirect No_60",
                  "Project /Indirect Desc_150",
                  "Gate (EVM Activity)_150",
                  "Module(MFL)_150",
                  "Status_45",
                  "Hrs_20",
                ]}
                TableRowHederAling="center"
                size="small"
                headerColor="#E6F2FF"
                className="custom-table"
                paddingTop="10px"
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            style={{ marginTop: "10px", justifyContent: "center" }}
            className={styles.myGrid}
            columns={12}
          >
            <Grid item md={2} lg={2}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(styles.actionButton)}
                    variant="primary"
                    data-testid="confirm-action"
                    style={{ marginRight: "5px" }}
                    // disabled="true"
                    onClick={handleDelete}
                   
                  >
                    Delete
                  </Button>

                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="tertiary"
                    //     disabled={(myState.chassisNo == null)}
                    onClick={handleCancelClick}
                    data-testid="confirm-action"
                    style={{ marginLeft: "30px" }}
                  >
                    Cancel
                  </Button>
                 
                </div>
              </div>
            </Grid>
          </Grid>
        {/* </> */}
    </div>
  );

  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail,
    },
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  const handleOk = () => {
    if (datesComingFromCalendar.length > 0) {
      history.push("/home");
    } else {
      window.location.reload();
    }
  };
  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Time Booking" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup
            header="Booking Details Individual"
            body={renderOther()}
          />
          {myState.checkTable && selectedProjectsDetails.length !== 0 && renderReport()}
        </div>
       
      </div>


      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
};

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ReportShiftUtilizationForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ReportShiftUtilizationForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportShiftUtilizationForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);